import { useContext, useState } from 'react';
import { ChildrenElements } from 'utils/interfaces/commonInterfacesAndTypes';
import PlaceContext from './place-context';
import { Place } from 'utils/interfaces/announcementForm';
import HTTPService from 'services/HTTPService/HTTPService';
import { NamedPlace } from 'utils/interfaces/place';
import { useRouter } from 'next/router';
import { countryPlaceIdToCode } from 'utils/functions/placeFunctions';
import NotificationContext from 'context/notification/notification-context';

const PlaceContextProvider = ({ children }: ChildrenElements) => {
   const [place, setPlace] = useState<Place | null>(null);
   const { locale } = useRouter();
   const { display } = useContext(NotificationContext);

   const setPlaceHandler = (placeId?: string, loadingPlaceholder?: string) => {
      if (!placeId) {
         setPlace(null);
         return;
      }

      const countryCode = countryPlaceIdToCode(placeId);
      const isPlaceCountry = countryCode !== placeId;
      const placeNameProperty = isPlaceCountry ? 'country' : 'city';

      if (loadingPlaceholder) {
         setPlace({ placeId, [placeNameProperty]: loadingPlaceholder });
      }

      HTTPService.getPlaceName(placeId)
         .then(res => {
            const typedLocale = locale as keyof NamedPlace['names'];
            const localPlaceName = res.data.names[typedLocale];
            setPlace({ placeId, [placeNameProperty]: localPlaceName });
         })
         .catch(() => {
            display({
               text: 'missing:error_downloading_data',
               duration: 5000,
               isSuccess: false,
            });
         });
   };

   return (
      <PlaceContext.Provider value={{ place, changePlace: setPlaceHandler }}>
         {children}
      </PlaceContext.Provider>
   );
};

export default PlaceContextProvider;
